import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChildren, QueryList, ElementRef} from '@angular/core';
import {DocumentsService} from "../../../../../services/document.service";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {QuillEditorComponent} from "ngx-quill";
import {FormArray, FormsModule} from "@angular/forms";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import {UtilsService} from "../../../../../services/utils.service";
import Swal from "sweetalert2";
import {RegistroAlimentosComponent} from "./registro-alimentos/registro-alimentos.component";
import { AnalisisSemanalComponent } from "./analisis-semanal/analisis-semanal.component";
import { CommonModule } from '@angular/common';
import {categoriasPlatillos} from "../../../../../models/platillo.model";

@Component({
  selector: 'app-analisis-alimentacion',
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    // QuillEditorComponent,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    NgForOf,
    RegistroAlimentosComponent,
    AnalisisSemanalComponent
],
  templateUrl: './analisis-alimentacion.component.html',
  styleUrl: './analisis-alimentacion.component.css'
})
export class AnalisisAlimentacionComponent implements OnInit, OnChanges{
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice

  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  seccionActive: any;
  macrosManual: boolean = true;
  FormMacrosManual: FormGroup;
  FormMacrosFormula: FormGroup;
  formDiasMacros: FormGroup;
  programaActivo: any
  checkAll: boolean = true

  intMetabolismoBasal: any;
  intTDEE: any;
  intObjetivoCalorias: any;
  intCarbohidratos: any;
  intPctCarbohidratos: any;
  intProteinas: any;
  intPctProteinas: any;
  intGrasas: any;
  intPctGrasas: any;
  programaFiltradoId: any;
  alimentacionPorMacros: boolean = true;

  ageArray = this.utilService.age();

  constructor(private documentService: DocumentsService, private fb: FormBuilder, private utilService: UtilsService){
    this.FormMacrosManual = this.fb.group({
      caloriasManual: [0, [Validators.required]],
      carbsGramos: [0, [Validators.required]],
      carbsPorcentaje: [0, [Validators.required]],
      proteGramos: [0, [Validators.required]],
      protePorcentaje: [0, [Validators.required]],
      grasaGramos: [0, [Validators.required]],
      grasaPorcentaje: [0, [Validators.required]],
    });

    this.FormMacrosFormula = this.fb.group({
      sexoFormula: ['0', [Validators.required]],
      edadFormula: ['0', [Validators.required]],
      alturaFormula: [0, [Validators.required]],
      pesoFormula: [0, [Validators.required]],
      actividadFormula: ['sedentario', [Validators.required]],
      objetivoFormula: ['deficit', [Validators.required]],
      deficitCantidadFormula: [0, [Validators.required]],
      superavitCantidadFormula: [0, [Validators.required]],
      grsProteinaPesoFormula: [0, [Validators.required]],
      porcentajeGrasaFormula: [0, [Validators.required]],
    });

    this.formDiasMacros = this.fb.group({
      // CHECKBOX WITH AN ARRAY OF CHECKBOXES THAT AT LEAST ONE MUST BE CHECKED
      macrosDias: this.fb.array([], [Validators.required])
    })

  }
  ngOnInit(): void {
    //this.getGuias();
    this.checkAll = true
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("=========================== onChanges Expediente Desde Alimentacion =======================================")
    console.log('detallePrograma', this.detallePrograma);
    console.log('detalleCliente', this.detalleCliente);
    this.seccionActive = 'registro'
    if (changes.detallePrograma) {
      //obtiene el tipo de alimentacion
      this.alimentacionPorMacros = this.detalleCliente.expediente.programas[0].configuracionPrograma.alimentacionPorMacros
      //agregar logica para saber cual es el programa activo, ahora se deja hardcode el primero del array
      let index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
      this.programaActivo = this.obtieneProgramaActual(this.detalleCliente)
      this.programaFiltradoId = this.programaActivo.configuracionPrograma.id
      this.setProgramaFiltrado(this.programaFiltradoId)
    }

  }

  obtieneProgramaActual(cliente){
    let programaActivo = null;
    const hoy = new Date();
    cliente.expediente?.programas.forEach((programa: any) => {
      const fechaInicio = new Date(programa.periodos[0].fechaInicioDate);
      const fechaFin = new Date(programa.periodos[programa.periodos.length - 1].fechaFinDate);
      if (hoy >= fechaInicio && hoy <= fechaFin) {
        programaActivo = programa;
      }
    });

    if(programaActivo == null){
      programaActivo = cliente.expediente.programas[cliente.expediente.programas.length - 1]
    }

    return programaActivo;

  }

  setProgramaFiltrado(programaId: any){
    //this.platillosFiltrados = this.editarGuia.detalle.filter((platillo: any) => platillo.categoria === this.filtrarGuiaPorCatePlatillo);
    let programa = this.detalleCliente.expediente.programas.filter((programa: any) => programa.configuracionPrograma.id === programaId);
    programa = programa[0];

    for(let i in programa.configuracionMacrosXdia){
      let fecha: any;
      fecha = programa.configuracionMacrosXdia[i].fecha;
      fecha = fecha.split("-");
      let newDate = new Date( fecha[2], fecha[1] - 1, fecha[0]);
      programa.configuracionMacrosXdia[i].timestamp = newDate.getTime() + 86399000;
      programa.configuracionMacrosXdia[i].timestampActual = Date.now();
      console.log(newDate.getTime());
    }

    console.log('macros x dia:', programa.configuracionMacrosXdia)
    this.programaActivo = programa
    this.programaFiltradoId = this.programaActivo.configuracionPrograma.id

  }

  changeSeccionActive(value: 'macros' | 'registro' | 'resumen') {
    this.seccionActive = value;
  }


  protected readonly categoriasPlatillos = categoriasPlatillos;
}